import Carousel from '../Carousel';
import Features from '../Features';

function Home() {
    return (
      <div className="App">
       <Carousel/>
       <Features/>
      </div>
    );
  }
  
export default Home;